import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=d4ba4e40&scoped=true&"
import script from "./Pane.vue?vue&type=script&lang=js&"
export * from "./Pane.vue?vue&type=script&lang=js&"
import style0 from "./Pane.vue?vue&type=style&index=0&id=d4ba4e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ba4e40",
  null
  
)

export default component.exports